export const formatIssueKey = (
  projectKey: string | null | undefined,
  seq: number | null | undefined
): string => {
  if (!projectKey || seq == null) return "";
  return `${projectKey}-${seq}`;
};

export const parseIssueKey = (
  issueKey: string | null | undefined
): { projectKey: string; seq: number } | null => {
  if (!issueKey) return null;
  const m = issueKey.match(/^([A-Z][A-Z0-9]*)-(\d+)$/);
  if (!m) return null;
  return { projectKey: m[1], seq: Number(m[2]) };
};

export const isValidProjectKey = (key: string | null | undefined): boolean => {
  if (!key) return false;
  return /^[A-Z][A-Z0-9]{1,9}$/.test(key);
};
